import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';

import {
  BEGIN,
  CREATE,
  FAILED,
  SUCCESSFUL,
} from '../../configs/actionNames';
import { USER_ACTION_LOG_PAGE_MODULE } from '../../configs/moduleNames';

export const LOAD_USER_ACTION_LIST = '_LOAD_USER_ACTION_LIST';

export const create = createDeferredAction(USER_ACTION_LOG_PAGE_MODULE + CREATE);
export const createSuccessful = createAction(USER_ACTION_LOG_PAGE_MODULE + CREATE + SUCCESSFUL);
export const createFailed = createAction(USER_ACTION_LOG_PAGE_MODULE + CREATE + FAILED);

export const loadUserActionList = createDeferredAction(USER_ACTION_LOG_PAGE_MODULE + LOAD_USER_ACTION_LIST);
export const loadUserActionListBegin = createAction(USER_ACTION_LOG_PAGE_MODULE + LOAD_USER_ACTION_LIST + BEGIN);
export const loadUserActionListSuccessful = createAction(USER_ACTION_LOG_PAGE_MODULE + LOAD_USER_ACTION_LIST + SUCCESSFUL);
export const loadUserActionListFailed = createAction(USER_ACTION_LOG_PAGE_MODULE + LOAD_USER_ACTION_LIST + FAILED);
